import { useState, useEffect } from "react";
import { getBook, setBookLike } from "../../../api/index";
import { useLocation } from "react-router-dom";

export const useBookData = (id: string | undefined) => {
    const [bookData, setBookData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [likeCount, setLikeCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (id) {
                    const data = await getBook(id);
                    setBookData(data);
                }
            } catch (error) {
               // console.error("Failed to fetch book data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchData();
    }, [id]);

    const handleLike = async () => {
        if (id) {
            try {
                await setBookLike(id);
                setBookData((prev: any) => {
                    const isLiked = prev?.like ?? false;
                    const newLikeCount = isLiked
                        ? (prev.likeCount ?? 0) - 1
                        : (prev.likeCount ?? 0) + 1;

                    return {
                        ...prev,
                        like: !isLiked,
                        likeCount: newLikeCount,
                    };
                });
            } catch (e) {
              //  console.error("Failed to like book:", e);
            }
        }
    };

    return { bookData, loading, likeCount, handleLike };
};
